module.exports = __webpack_public_path__ + "static/media/SUR.3be52c71.svg";